import { render, staticRenderFns } from "./ComponentStyle.vue?vue&type=template&id=1ed4d190&scoped=true"
import script from "./ComponentStyle.vue?vue&type=script&lang=js"
export * from "./ComponentStyle.vue?vue&type=script&lang=js"
import style0 from "./ComponentStyle.vue?vue&type=style&index=0&id=1ed4d190&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4d190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed4d190')) {
      api.createRecord('1ed4d190', component.options)
    } else {
      api.reload('1ed4d190', component.options)
    }
    module.hot.accept("./ComponentStyle.vue?vue&type=template&id=1ed4d190&scoped=true", function () {
      api.rerender('1ed4d190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/ComponentStyle.vue"
export default component.exports